var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","padless":""}},[_c('v-card',{staticClass:"text-center",attrs:{"flat":"","tile":"","width":"100%"}},[_c('v-divider'),_c('v-card-text',[_vm._v(" "+_vm._s(new Date().getFullYear())+" © THAAG e.V. ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }